"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentCardSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PaymentCardSkeleton = ({
  className
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
  className: className,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    width: 150,
    height: 45,
    sx: {
      marginTop: 4
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 45,
    width: "100%",
    sx: {
      marginTop: 4
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 45,
    width: "100%",
    sx: {
      marginTop: 4
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    height: 45,
    width: "100%",
    sx: {
      marginTop: 4
    }
  })]
});
exports.PaymentCardSkeleton = PaymentCardSkeleton;
//# sourceMappingURL=PaymentCardSkeleton.js.map